import languages from './maps/languages';
function getLanguageName(options, possibleSourceLanguage = 'en') {
    let targetLanguage;
    let sourceLanguage;
    if (typeof options === 'string') {
        targetLanguage = options;
        sourceLanguage = possibleSourceLanguage;
    }
    if (typeof options === 'object') {
        targetLanguage = options.targetLanguage;
        sourceLanguage = options.sourceLanguage || 'en';
    }
    const hasSourceLanguage = sourceLanguage in languages;
    const hasTargetLanguage = hasSourceLanguage && targetLanguage in languages[sourceLanguage];
    if (hasSourceLanguage && hasTargetLanguage) {
        return languages[sourceLanguage][targetLanguage];
    }
    if (languages.en[targetLanguage]) {
        return languages.en[targetLanguage];
    }
    return '';
}
export { getLanguageName };
export default getLanguageName;
